"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesSoldStatsWrapper$ = exports.PropertiesSoldStatsWrapper$outboundSchema = exports.PropertiesSoldStatsWrapper$inboundSchema = void 0;
exports.propertiesSoldStatsWrapperToJSON = propertiesSoldStatsWrapperToJSON;
exports.propertiesSoldStatsWrapperFromJSON = propertiesSoldStatsWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiessold_js_1 = require("./propertiessold.js");
const propertiessoldbytype_js_1 = require("./propertiessoldbytype.js");
/** @internal */
exports.PropertiesSoldStatsWrapper$inboundSchema = z.object({
    locality: propertiessold_js_1.PropertiesSold$inboundSchema,
    property_type: z.array(propertiessoldbytype_js_1.PropertiesSoldByType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.PropertiesSoldStatsWrapper$outboundSchema = z.object({
    locality: propertiessold_js_1.PropertiesSold$outboundSchema,
    propertyType: z.array(propertiessoldbytype_js_1.PropertiesSoldByType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesSoldStatsWrapper$;
(function (PropertiesSoldStatsWrapper$) {
    /** @deprecated use `PropertiesSoldStatsWrapper$inboundSchema` instead. */
    PropertiesSoldStatsWrapper$.inboundSchema = exports.PropertiesSoldStatsWrapper$inboundSchema;
    /** @deprecated use `PropertiesSoldStatsWrapper$outboundSchema` instead. */
    PropertiesSoldStatsWrapper$.outboundSchema = exports.PropertiesSoldStatsWrapper$outboundSchema;
})(PropertiesSoldStatsWrapper$ || (exports.PropertiesSoldStatsWrapper$ = PropertiesSoldStatsWrapper$ = {}));
function propertiesSoldStatsWrapperToJSON(propertiesSoldStatsWrapper) {
    return JSON.stringify(exports.PropertiesSoldStatsWrapper$outboundSchema.parse(propertiesSoldStatsWrapper));
}
function propertiesSoldStatsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesSoldStatsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesSoldStatsWrapper' from JSON`);
}
//# sourceMappingURL=propertiessoldstatswrapper.js.map